<!-- 195(남북하나재단) 전용 한국어 과정 소개 — 커리큘럼 표 이미지 한 장만 노출 -->
<template>
  <div>
    <div class="hidden pc:block bg-wrapper">
      <div class="flex items-center justify-center bg py-[76px] max-w-[1920px] mx-auto">
        <p class="text-[40px] font-bold text-neutral-950">한국어 과정</p>
      </div>
    </div>

    <section class="pt-[55px] pb-[70px] pc:pt-[70px] pc:pb-[140px]">
      <!-- 모바일: 표가 넓어 가로 스크롤 -->
      <div class="overflow-x-auto px-[18px] pc:hidden">
        <img src="@/assets/images/main/hana/curriculum-ko.png" alt="한국어 커리큘럼" class="w-[1200px] min-w-[1200px]" />
      </div>

      <div class="mx-auto hidden max-w-[1200px] pc:block">
        <img src="@/assets/images/main/hana/curriculum-ko.png" alt="한국어 커리큘럼" />
      </div>
    </section>
  </div>
</template>
<script>
export default {
  components: {},
};
</script>
